<template>
  <div class="market-sidebar__apps">
    <h2 class="market-sidebar__title">
      {{ t('apps_and_extensions') }}
    </h2>

    <div
        v-if="appsCagetorized[MarketInfoAppType.Mobile]?.length"
        class="mobile-apps"
    >
      <h3 class="market-sidebar__title-small">
        {{ t('mobile_app') }}
      </h3>
      <div
          class="f fcol gap12"
      >
        <a
            v-for="app in appsCagetorized[MarketInfoAppType.Mobile]"
            :key="app?.link"
            :href="app?.link || ''"
            class="btn btn-app-xl"
            rel="noopener noreferrer nofollow"
        >
          <img :alt="app?.name" :src="`/img/apps/${app?.logo}`">
          <div>
            <p class="btn-app-xl-top">{{ t('get_it_on') }}</p>
            <p class="btn-app-xl-bottom">{{ app?.name }}</p>
          </div>
        </a>
      </div>
    </div>

    <div
        v-if="appsCagetorized[MarketInfoAppType.Extention]?.length"
        class="mobile-apps"
    >
      <h3 class="market-sidebar__title-small">
        {{ t('browser_extension') }}
      </h3>
      <div
          class="f fcol gap12"
      >
        <a
            v-for="app in appsCagetorized[MarketInfoAppType.Extention]"
            :key="app?.link"
            :href="app?.link || ''"
            class="btn btn-app-xl"
            rel="noopener noreferrer nofollow"
        >
          <svg>
            <use xlink:href="/icons/sprite.svg#i-puzzle"></use>
          </svg>
          <!--          <img :alt="app?.name" :src="app?.logo">-->
          <div>
            <p class="btn-app-xl-top">{{ t('install_for_your_browser') }}</p>
            <p class="btn-app-xl-bottom">{{ app?.name }}</p>
          </div>
        </a>
      </div>
    </div>

    <div
        v-if="appsCagetorized[MarketInfoAppType.Desktop]?.length"
        class=""
    >
      <h3 class="market-sidebar__title-small">
        {{ t('desktop_app') }}
      </h3>
      <div
          class="desk-apps"
      >
        <a
            v-for="app in appsCagetorized[MarketInfoAppType.Desktop]"
            :key="app?.link"
            v-tooltip="app?.name"
            :href="app?.link || ''"
            class="btn btn-app-sm"
            rel="noopener noreferrer nofollow"
        >
          <img :alt="app?.name" :src="`/img/apps/${app?.logo}`">
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {MarketFullInfoApp, MarketInfoAppType} from "~/graphql/generated/schema-types";

const props = defineProps<{
  apps: MarketFullInfoApp[]
}>()
const {t} = useI18n()

const appsCagetorized = computed(() =>
    props.apps?.reduce((acc, app) => {
      if (app?.type) {
        if (!acc[app.type]) {
          acc[app.type] = [];
        }
        acc[app.type].push(app);
      }
      return acc;
    }, {} as Record<MarketInfoAppType, MarketFullInfoApp[]>)
);
</script>

<style lang="scss" scoped>
@use 'sass:color';

.market-sidebar__apps {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .btn-app-xl {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    padding: 16px;
    border-radius: 12px;
    background: var(--surfaces-container);
    width: 100%;

    &:hover {
      background: color-mix(IN srgb, var(--surfaces-container) 97%, white);
    }

    img, svg {
      width: 36px;
      height: 36px;
    }

    &-top {
      color: var(--surfaces-on-surface-variable);
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 8px;
    }

    &-bottom {
      color: var(--surfaces-on-surface);
      font-size: 14px;
      font-weight: 600;
      line-height: 18px; /* 128.571% */
    }
  }

  .desk-apps {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }

  .btn-app-sm {
    padding: 20px 24px;
    border-radius: 12px;
    background: var(--surfaces-container);
    width: 100%;

    &:hover {
      background: color-mix(IN srgb, var(--surfaces-container) 97%, white);
    }

    img {
      width: 36px;
      height: 36px;
    }
  }

  @media screen and (max-width: 850px) {
    padding-top: 16px;
  }
}
</style>
